import PostFormController from "./post_form_controller";

export default class extends PostFormController { }
